import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConnectionCard } from '@feathr/components';

import type { IFacebookPage } from '../MetaConnectedView.hooks';

interface IMetaFacebookPagesCardProps {
  pages: IFacebookPage[];
}

function MetaFacebookPagesCard({ pages }: Readonly<IMetaFacebookPagesCardProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <ConnectionCard name={'meta-facebook-pages-card'}>
      <ConnectionCard.Header count={pages.length} icon={faFacebook} iconTheme={'blue'}>
        {t('Facebook Pages')}
      </ConnectionCard.Header>
      <ConnectionCard.Items>
        {pages.map((page) => (
          <ConnectionCard.Item href={page.url} key={page.id}>
            {page.name}
          </ConnectionCard.Item>
        ))}
      </ConnectionCard.Items>
    </ConnectionCard>
  );
}

export default MetaFacebookPagesCard;
